import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Container, Row } from 'reactstrap'
import './FaqComponent.scss'
import { Component } from 'react'
import Moment from 'react-moment'
import Cancel from '@material-ui/icons/Cancel'
import PropTypes from 'prop-types'

export default class FaqComponent extends Component {
  static propTypes = {
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    })
  }

  constructor (props) {
    super (props)

    this.state = {
      hideShortcutBanner: false
    }
  }
  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of <strong>FAQ</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }
  render () {
    return (
      <Container>
        <Row className='wrapper faqComponent'>
          {this._renderShortcut()}
          <Box>
            <Typography>Last updated April 27, 2021</Typography>
          </Box>
          <Box className='faq-heading'>
            <b>FAQ</b>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>How do I access the Diesel Labs platform?</b>
            </Typography>
            <Typography>
              <span>
                Go to&nbsp;
                <a href='https://insights.diesellabs.com'>
                  https://insights.diesellabs.com
                </a>
                &nbsp;and enter your username and password. If you are having trouble
                logging in or have forgotten your username and/or password, please
                contact&nbsp;
                <a href='mailto:support@diesellabs.com'>support@diesellabs.com</a>
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>How do I change my password? </b>
            </Typography>
            <Typography>
              <span>
                Navigate to&nbsp;
                <a href='https://insights.diesellabs.com'>
                  https://insights.diesellabs.com
                </a>
                &nbsp;and click ‘Forgot password.’ You’ll be prompted to enter your
                email address, and a reset link will be emailed to you. Click the
                link in the email and enter a new password.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>I don’t see the audience that I’m looking for in the Library.</b>
            </Typography>
            <Typography>
              <span>
                If you don’t see the audience(s) you need, please email&nbsp;
                <a href='mailto:support@diesellabs.com'>support@diesellabs.com</a>
                .
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>What if I need a custom audience for analysis?</b>
            </Typography>
            <Typography>
              <span>
                Please email&nbsp;
                <a href='mailto:support@diesellabs.com'>support@diesellabs.com</a>
                , we can combine audiences into a ‘comp set’, create custom
                segments, time bound existing audiences and a lot more!
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>What does the Homepage show?</b>
            </Typography>
            <Typography>
              <span>
                This is an optional view. If you do not see the option and would
                like to learn more, please email&nbsp;
                <a href='mailto:support@diesellabs.com'>support@diesellabs.com</a>
                . The Homepage provides a roll up analysis of your network or
                brand(s), and provides relevant benchmarks for context. Click on
                the icon next to the title of each module to learn more about the
                individual insights represented.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>What does the Media Preferences page show?</b>
            </Typography>
            <Typography>
              <span>
                The charts summarize the media preferences for the selected
                audience by comparing their engagement behaviors to that of all
                the other audiences in the Diesel Labs platform. So for example, a
                score of 10% for Netflix means your selected audience overindexes
                in engagement with Netflix original content vs the average
                audience. Click on any of the bar charts to filter the leaderboard
                table on the right and see which pieces of content are driving the
                results.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>What is an affinity score?</b>
            </Typography>
            <Typography>
              <span>
                The affinity score describes the strength of the relationship
                between the selected audience and the piece of content or item in
                the leaderboard table. A score of 5x means that the selected
                audience overindexes in engagement with that line item 5 times
                more than the average audience. Indices over 100x typically
                indicate there is a relationship between the two audiences in
                question (for example a shared actor, or other element helping
                drive the high score).
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>How are demographics for an audience determined?</b>
            </Typography>
            <Typography>
              <span>
                Demographics are a modeled set of statistics. Many of the social
                media platforms that Diesel Labs pulls data from do not require
                user submitted demographic information, and as such we use a
                sophisticated modeling approach (using information such as bio,
                username, post contents and history) to determine gender and age.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>How often is the data for an audience updated?</b>
            </Typography>
            <Typography>
              <span>
                The platform provides a rolling 18-month view of the preferences
                and behaviors of the selected audience. Contact&nbsp;
                <a href='mailto:support@diesellabs.com'>support@diesellabs.com</a>
                &nbsp;if you need to analyze a custom time period.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>
                How are the trending videos determined? How often are they
                updated?
              </b>
            </Typography>
            <Typography>
              <span>
                The trending videos are updated in real time and are based on
                engagement activity from the last 72 hours. Please note that this
                means that if you load the page multiple times in one day, the
                results could vary.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>What does the Anticipation page show?</b>
            </Typography>
            <Typography>
              <span>
                The Anticipation view provides insight into the upcoming content
                your selected audience is engaging with most. It includes shows,
                movies, and video trailers and ‘teasers’ from YouTube.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>
                Why are the trending videos different from the video channels with
                high affinity?
              </b>
            </Typography>
            <Typography>
              <span>
                The Diesel trending algorithm analyzes the last 72 hour period in
                real-time to rank which videos your audience is watching right
                now. Your video plan is assessing 12+ months of media consumption
                behaviors to showcase a stable list of video channels that your
                audience engages with on a more consistent basis. This means that
                on occasion trending videos might be listed that are not from the
                video channels listed in the plan.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>Can I export my plans?</b>
            </Typography>
            <Typography>
              <span>
                Yes, there is an export button in the top right corner of the
                platform (downward arrow icon). You can download the complete data
                set or opt to download the results based on the filters you have
                set on the page.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography className='faq-question'>
              <b>What does the Campaign page show?</b>
            </Typography>
            <Typography>
              <span>
                This is an optional view, if you do not see the option and would
                like to learn more please email&nbsp;
                <a href='mailto:support@diesellabs.com'>support@diesellabs.com</a>
                . The Campaign page provides real-time performance insights for a
                campaign. It tracks affinity over time, as well as the campaign’s
                impact on audience demographics and lifestyles, engagement, etc.
              </span>
            </Typography>
          </Box>
          <Box className='faq-question-answer-section'>
            <Typography>
              <span>
                More questions? Contact us:&nbsp;
                <a href='mailto:support@diesellabs.com'>support@diesellabs.com</a>
                .
              </span>
            </Typography>
          </Box>
        </Row>
      </Container>
    )
  }
}